export default __webpack_public_path__ + "static/char-58-16b2dbb1c113db64da591e3203b4d2f5.gif";